import { useToast } from "@/hooks/use-toast";
import { useMarketingSettings, useUpdateMarketingSettings } from "@/hooks/sms/useMarketingSettings";

/**
 * The one kill-switch implementation shared by every emergency-stop surface.
 * `checked` follows the saved row (or the in-flight value while a change is
 * pending), so a failed update never leaves the control showing a state the
 * database does not have; a failure also raises a destructive toast.
 */
export const useKillSwitch = () => {
  const { data: settings } = useMarketingSettings();
  const updateSettings = useUpdateMarketingSettings();
  const { toast } = useToast();

  const pendingValue = updateSettings.isPending ? updateSettings.variables?.kill_switch : undefined;
  const checked = pendingValue ?? settings?.kill_switch ?? false;

  const setKillSwitch = (next: boolean) => {
    if (!settings) return;
    updateSettings.mutate(
      { store_id: settings.store_id, kill_switch: next },
      {
        onError: (error) => {
          toast({
            title: next ? "Emergency stop did not turn on" : "Emergency stop did not turn off",
            description: `${error instanceof Error ? error.message : "Something went wrong."} Try again.`,
            variant: "destructive",
          });
        },
      },
    );
  };

  return { settings, checked, setKillSwitch, isPending: updateSettings.isPending };
};
